import { HttpErrorResponse } from '@angular/common/http';
import { inject, Service, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EntityKey } from '../entity/entity';
import { QuoteService } from './quote-service';

@Service()
export class PaperPilotService {
  private readonly quoteService = inject(QuoteService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly router = inject(Router);

  create(key: EntityKey, busy: WritableSignal<boolean>, onError: (error: HttpErrorResponse) => void): void {
    busy.set(true);
    this.quoteService.createPaperPilot(key).subscribe({
      next: (response) => {
        busy.set(false);
        if (response.messages && response.messages.length > 0) {
          this.snackBar.open(response.messages.join(' '), 'Close');
        }
        this.router.navigate(['quotes', response.updated.id.entityId, response.updated.id.entityRevision]);
      },
      error: (error: HttpErrorResponse) => onError(error),
    });
  }
}
